<template>
	<div class="add-box">
		<el-dialog v-model="dialogVisible" :title="title" width="38%" :before-close="handleClose">
			<el-form ref="form" :model="Dform" :rules="rules" label-width="120px">
				<el-row>
					<el-form-item label="学校" prop="region">
						<el-select v-model="Dform.region" filterable placeholder="请选择学校" @change="schoolClick" @click="schoolPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in schoolList"
								:key="item.value">
							</el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="school_loading"><text>加载中...</text></div> -->
					</el-form-item>
					<el-form-item label="家长电话1" prop="">
						<el-input v-model="Dform.parentsCall"></el-input>
					</el-form-item>

					<el-form-item label="年级" prop="classes">
						<el-select v-model="Dform.classes" filterable placeholder="请选择年级" @change="classClick" @click="gradePost()">
							<el-option :label="item.name" :value="item.id" v-for="item in gradeDataList" :key="item.value"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="grade_loading"><text>加载中...</text></div> -->
					</el-form-item>
					<el-form-item label="家长电话2" prop="">
						<el-input v-model="Dform.parentsCall2"></el-input>
					</el-form-item>
					<el-form-item label="班级" prop="classes2">
						<el-select v-model="Dform.classes2" filterable placeholder="请选择班级" @click="classPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="class_loading"><text>加载中...</text></div> -->
					</el-form-item>
				
					<el-form-item label="家长电话3" prop="">
						<el-input v-model="Dform.parentsCall3"></el-input>
					</el-form-item>
					<el-form-item label="姓名" prop="name">
						<el-input v-model="Dform.name"></el-input>
					</el-form-item>
					<el-form-item label="家长电话4" prop="">
						<el-input v-model="Dform.mobileFour"></el-input>
					</el-form-item>
					<el-form-item label="学号" prop="studentId" v-if="this.titleValue != '修改学生信息'">
						<el-input v-model="Dform.studentId"></el-input>
					</el-form-item>
					<el-form-item label="学号" prop="studentId" v-else>
						<el-input v-model="Dform.studentId" disabled></el-input>
					</el-form-item>
					<el-form-item label="家长电话5" prop="">
						<el-input v-model="Dform.mobileFive"></el-input>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="NFC" prop="">
						<el-input v-model="Dform.Nfc" ></el-input>
					</el-form-item>

					<el-form-item label="国籍" prop="">
						<el-input v-model="Dform.international"></el-input>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="IMEI" prop="">
						<el-input v-model="Dform.Imei" :disabled="this.titleValue != '修改学生信息'?false:true"></el-input>
					</el-form-item>
					<el-form-item label="地址" prop="">
						<el-input v-model="Dform.address"></el-input>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="性别">
						<el-radio-group v-model="Dform.sex">
							<el-radio label="男"></el-radio>
							<el-radio label="女"></el-radio>
						</el-radio-group>
					</el-form-item>
					
				</el-row>
					<el-form-item label="类型" >
						<el-select v-model="Dform.liveSchoolValue" filterable placeholder="请选择" @click="classPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in liveSchoolList" :key="item.value"></el-option>
						</el-select>
					</el-form-item>
				
				<el-row>
					<el-form-item label="通行策略" prop="strategy">
						<el-select v-model="Dform.strategy" filterable placeholder="请选择通行策略" multiple>
							<el-option v-for="item in strategy" :key="item.value" :label="item.strategyName" :value="item.strategyId"></el-option>
						</el-select>
					</el-form-item>
				</el-row>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="handleClose">返回</el-button>
					<el-button type="primary" @click="submitForm('form')">
						提交
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addStudent,
		updateStudentInfo,
		schoolList,
		gradeList,
		findClassList,
		strategyList
	} from '@/assets/api/renyuan';
	
	import { ElMessage,ElLoading } from 'element-plus'
	
	export default {
		props: ['titleValue', 'detailsObj', 'schoolData', 'defaultSchoolId'],
		components: {

		},
		data() {
			return {
				Dform: {
					region: '',
					name: '',
					classes: '',
					classes2: '',
					strategy: [],
					studentId: '',
					parentsCall: '',
					parentsCall2: '',
					parentsCall3: '',
					sex: '男',
					Rfid: '',
					Nfc: '',
					Imei: '',
					international: '',
					address: '',
					mobileFive: '',
					mobileFour: "",
					liveSchoolValue: 0 // 0走读；1住校
				},
				strategy: [],
				dialogVisible: true,
				title: '',
				schoolList: [],
				gradeDataList: [],
				classList: [],
				rules: {
					imei: [{
						required: true,
						message: '请输入IMEI',
						trigger: 'blur'
					}, ],
					region: [{
						required: true,
						message: '请选学校',
						trigger: 'change'
					}],
					classes: [{
						required: true,
						message: '请选班级',
						trigger: 'change'
					}],
					classes2: [{
						required: true,
						message: '请选班级',
						trigger: 'change'
					}],
					studentId: [{
						required: true,
						message: '请输入学号',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: '请输入名字',
						trigger: 'change'
					}],
				},
				school_loading : false,
				grade_loading : false,
				class_loading : false,
				liveSchoolList: [
					{
						name: '走读',
						id: 0
					},
					{
						name: '住校',
						id: 1
					},
				]
			};
		},
		created() {
			this.title = this.titleValue
			// 优先使用父组件传入的学校列表，避免重复请求
			if (this.schoolData && this.schoolData.length > 0) {
				this.schoolList = this.schoolData
			}
			if (this.titleValue == '新增学生') {
				// 如果列表页已经选了学校，新增时默认带上
				if (this.defaultSchoolId) {
					this.Dform.region = this.defaultSchoolId
				}
			}
			if (this.titleValue == '修改学生信息') {
				this.Dform.region = this.detailsObj.schoolId
				this.Dform.name = this.detailsObj.studentName
				// this.Dform.classes = this.detailsObj.gradeId
				// this.Dform.classes2 = this.detailsObj.classId
				this.Dform.studentId = this.detailsObj.studentNo
				this.Dform.parentsCall = this.detailsObj.mobileOne
				this.Dform.parentsCall2 = this.detailsObj.mobileTwo
				this.Dform.parentsCall3 = this.detailsObj.mobileThree
				this.Dform.mobileFive = this.detailsObj.mobileFive
				this.Dform.mobileFour = this.detailsObj.mobileFour
				if(this.detailsObj.strategyId){
					let data = [];
					this.detailsObj.strategyId.split(',').forEach((obj) => {
						data.push(parseInt(obj));
					});
					this.Dform.strategy = data
				}
				this.Dform.Rfid = this.detailsObj.rfid
				this.Dform.Nfc = this.detailsObj.nfc
				this.Dform.Imei = this.detailsObj.imei
				this.Dform.international = this.detailsObj.country
				this.Dform.sex = this.detailsObj.sex == 0 ? '女' : '男'
				this.Dform.address = this.detailsObj.address
				this.Dform.liveSchoolValue = this.detailsObj.liveSchool
				console.log(this.detailsObj, '修改页');
			}
		},
		async mounted() {
			this.getStrategy()
			await this.initCascade()
		},
		methods: {
			async initCascade() {
				// 编辑模式下如果没有传入学校列表，兜底请求
				if (this.titleValue == '修改学生信息' && this.schoolList.length === 0) {
					await this.schoolPost()
				}
				if (!this.Dform.region) {
					return
				}
				// 加载年级
				await this.gradePost()
				// 编辑模式下回显年级并加载班级
				if (this.titleValue == '修改学生信息' && this.detailsObj.gradeId) {
					this.Dform.classes = this.detailsObj.gradeId
					await this.classPost()
					if (this.detailsObj.classId) {
						this.Dform.classes2 = this.detailsObj.classId
					}
				}
			},

			async classClick() {
				this.Dform.classes2 = ''
				this.classList = []
				if (this.Dform.classes) {
					await this.classPost();
				}
			},

			async classPost(){
				let params = {
					page: '1',
					pageSize: '999',
				}
				this.class_loading = true;
				try {
					const res = await findClassList(params, this.Dform.classes);
					this.classList = res.data.data;
				} catch (err) {
					console.log(err);
				} finally {
					this.class_loading = false;
				}
			},


			async schoolClick() {
				this.Dform.classes = ''
				this.Dform.classes2 = ''
				this.gradeDataList = []
				this.classList = []
				if (this.Dform.region) {
					await this.gradePost();
				}
			},


			async gradePost(){
				let params = {
					page: '1',
					pageSize: '999',
				}
				this.grade_loading = true;
				try {
					const res = await gradeList(params, this.Dform.region);
					this.gradeDataList = res.data.data;
				} catch (err) {
					console.log(err);
				} finally {
					this.grade_loading = false;
				}
			},

			async schoolPost(schooName) {
				if (this.schoolList.length > 0) {
					return;
				}
				this.school_loading = true;
				try {
					let params = JSON.parse(localStorage.getItem('user')).id;
					const res = await schoolList(params);
					this.schoolList = res.data.data
				} catch (err) {
					console.log(err);
				} finally {
					this.school_loading = false;
				}
			},
			
			
			submitForm(formName) {
				console.log(this.Dform, this.title);
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.title == '新增学生') {
							this.addStudent()
						} else if (this.title == '修改学生信息') {
							console.log('修改');
							this.updateStudentInfoClick()
							console.log(8888);
						}
					} else {
						console.log(valid, '校验未通过');
						return false;
					}
				});
			},
			handleClose() {
				this.$emit('addClick')
			},
			updateStudentInfoClick() {
				let params = {
					studentId: this.detailsObj.studentId,
					classId: this.Dform.classes2,
					mobileOne: this.Dform.parentsCall,
					mobileTwo: this.Dform.parentsCall2,
					mobileThree: this.Dform.parentsCall3,
					mobileFive: this.Dform.mobileFive,
					mobileFour: this.Dform.mobileFour,
					country: this.Dform.international,
					strategyId: this.Dform.strategy.join(','),
					imei: this.Dform.Imei,
					nfc: this.Dform.Nfc,
					sex: this.Dform.sex == '女' ? '0' : '1', // 性别,
					stuName: this.Dform.name,
					address: this.Dform.address,
					liveSchool: this.Dform.liveSchoolValue, // 类型
				}
				updateStudentInfo(params).then((res) => {
					console.log(res, 4444);
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.handleClose()
				}).catch((err) => {
					// console.log(err,6666);
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			addStudent() {
				console.log(789);
				let params = {
					address: this.Dform.address, // 地址
					classId: this.Dform.classes2, // 班级
					country: this.Dform.international, // 国籍
					imei: this.Dform.Imei, // Imei
					mobileOne: this.Dform.parentsCall, // 家长电话
					mobileThree: this.Dform.parentsCall2, // 家长电话2
					mobileTwo: this.Dform.parentsCall3, // 家长电话3
					mobileTwo: this.Dform.parentsCall3, // 家长电话3
					mobileFive: this.Dform.mobileFive,
					mobileFour: this.Dform.mobileFour,
					strategyId: this.Dform.strategy.join(','),
					nfc: this.Dform.Nfc, // nfc
					liveSchool: this.Dform.liveSchoolValue, // 类型
					// rfid: this.Dform.Rfid, // rfid
					sex: this.Dform.sex == '女' ? '0' : '1', // 性别
					studentName: this.Dform.name, // 姓名
					studentNo: this.Dform.studentId, // 学号
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				addStudent(params).then((res) => {
					console.log(res, '新增学生');
					this.$message({
						type: 'success',
						message: '新增成功!'
					});
					this.handleClose()
				}).catch((err) => {
					console.log(err);
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},

			getStrategy() {
				let loginid = JSON.parse(localStorage.getItem('user')).id;
				strategyList(loginid).then((res) => {
					this.strategy = res.data.data
				}).catch((err) => {
					console.log(err);
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			
			openElLoading(text){
				this.elLoading = ElLoading.service({
					lock: true,
					text: `${text}...`,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			
			closeElLoading(){
				if(this.elLoading){
					this.elLoading.close();
					this.elLoading = null;
				}
			},
		},
	};
</script>
<style scoped lang="scss">
	:deep() {
		.el-dialog__body {
			// height: 75%;
			max-height: 500px;
			// min-height: 350px;        
			overflow: auto;
		}

		// }
		.el-input--small {
			width: 250px;
		}

		.el-select .el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-form-item--small .el-form-item__label {
			height: 35px;
			line-height: 35px;
		}

		.el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-radio.el-radio--small .el-radio__inner {
			width: 14px;
			height: 14px;
		}

		.el-input__wrapper {
			height: 35px;
			line-height: 35px;
		}

		.el-date-editor.el-input,
		.el-date-editor.el-input__wrapper {
			height: 35px !important;
		}

		.el-select--small .el-select__wrapper {
			width: 250px;
			height: auto;
			min-height: 35px;
		}
	}
	
	.loading_view{
		position: absolute;
		padding: 5px;
		background-color: rgba(0, 0, 0, 0.8);
		width: 100%;
		color: white;
		text-align: center;
		border-radius: 5px;
	}
</style>